import approvalPersonService from "../../../../services/procurementService/approvalPersonService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_APPROVALPERSONS } from "../../../../utils/constants";
import { ApprovalPersonInterface } from "../../../../models/ProcurementModule/ApprovalPerson";

interface DeleteApprovalPersonContext {
  previousApprovalPersons: ApprovalPersonInterface[];
  deletedApprovalPerson: ApprovalPersonInterface | undefined;
}

const useDeleteApprovalPerson = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the customer to delete
    DeleteApprovalPersonContext
  >({
    mutationFn: approvalPersonService.Remove, // Remove should take a string ID

    onMutate: (approvalPersonId: string) => {
      const previousApprovalPersons =
        queryClient.getQueryData<ApprovalPersonInterface[]>([
          CACHE_KEY_APPROVALPERSONS,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<ApprovalPersonInterface[]>(
        [CACHE_KEY_APPROVALPERSONS, page, pageSize],
        previousApprovalPersons.filter(
          (approvalPerson) => approvalPerson.id !== approvalPersonId
        ) // Use statusId to filter
      );

      return {
        previousApprovalPersons,
        deletedApprovalPerson: previousApprovalPersons.find(
          (approvalPerson) => approvalPerson.id === approvalPersonId
        ),
      };
    },

    onError: (error, approvalPersonId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<ApprovalPersonInterface[]>(
        [CACHE_KEY_APPROVALPERSONS, page, pageSize],
        context.previousApprovalPersons
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteApprovalPerson;
